import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { ITailNumber } from 'src/models/tail-number.model';
import services from 'src/services/tail-number.service';

export const actionTypes = {
  TAIL_NUMBER_FETCH: 'TAIL_NUMBER_FETCH',
  TAIL_NUMBER_ADD: 'TAIL_NUMBER_ADD',
  TAIL_NUMBER_UPDATE: 'TAIL_NUMBER_UPDATE',
  TAIL_NUMBER_DELETE: 'TAIL_NUMBER_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.TAIL_NUMBER_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.TAIL_NUMBER_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.TAIL_NUMBER_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.TAIL_NUMBER_DELETE,
    service: services.itemDELETE,
  },
};

export type ITailNumberAsync = typeof asyncActions;

export interface ITailNumberState extends ICommonState<ITailNumberAsync> {
  data?: ITailNumber;
  list: ITailNumber[];
  total: number;
}

export const defaultState: ITailNumberState = {
  status: {},
  list: [],
  total: 0,
};

const TailNumberReducer = (
  state: ITailNumberState = defaultState,
  action: IReducerAction<ITailNumberAsync>
): ITailNumberState => {
  switch (action.type) {
    case actionTypes.TAIL_NUMBER_FETCH: {
      return {
        ...state,
        list: action.payload?.tailNumbers.rows ?? [],
        total: action.payload?.tailNumbers.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default TailNumberReducer;
